import { type paths as customerPaths } from "@njbsoft/types/customer";
import { buildClient, type ApiClientOptions } from "./client";

// The base-URL suffix the customer RefreshManager MUST use. The shared
// RefreshManager POSTs to `${baseUrl}/auth/refresh`; the customer stack
// mints njbsoft-customer refresh tokens that ONLY
// /api/v1/customer/auth/refresh can redeem (the audience discriminator).
// Building the customer RefreshManager with the bare API_URL would route
// refresh to the internal endpoint, which rejects the customer token by
// design. apps/customer/src/lib/auth.tsx composes
// `${API_URL}${CUSTOMER_REFRESH_PATH_SUFFIX}` as its baseUrl, NOT the bare
// API_URL the company app uses, and reads the customer /auth/refresh 200 body
// { access_token, refresh_token, expires_at } — the three field names
// RefreshManager.onTokenRefreshed expects.
//
// Device-trust does NOT reach this stack: the internal device-trust cookie is
// path-scoped to /api/v1/auth, so it does not cover the customer auth surface
// /api/v1/customer/auth. The customer stack ships no device-trust; a customer
// MFA-remember-device feature (a customer-scoped cookie path
// /api/v1/customer/auth) is a deliberate net-new decision, never a silent
// assumption that device-trust works on the customer surface.
export const CUSTOMER_REFRESH_PATH_SUFFIX = "/customer";

// Typed openapi-fetch client for the /api/v1/customer stack. The customer
// portal mints its own njbsoft-customer-audience tokens via the customer
// auth surface; this client carries that bearer + the customer
// RefreshManager. Customer auth sub-routes (/auth/*) are handled by the
// RefreshManager pointed at /api/v1/customer/auth/refresh (see
// CUSTOMER_REFRESH_PATH_SUFFIX).
export function createCustomerApiClient(options: ApiClientOptions) {
  return buildClient<customerPaths>(options);
}

export type CustomerApiClient = ReturnType<typeof createCustomerApiClient>;
